// @core/api/endpoints/calendar/create_calendar_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarPolicyResponse,
  CreateCalendarPolicyRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Create calendar policy
 * Creates a calendar management policy for a scope entity (calendar, org, team). Configures default visibility, reminders, attendee settings, and conference link behavior.
 */
export async function CreateCalendarPolicy(
  data: CreateCalendarPolicyRequest,
  options?: RequestOptions
): Promise<CalendarPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/calendar-policies`;
  const requestOptions = options;
  return client.post<CalendarPolicyResponse>(requestPath, data, requestOptions);
}
